import moment from 'moment';
import $ from 'jquery';
import colors from './colors';
import { Constants } from 'utils';
import Swal from 'sweetalert2';

class Globals {
  // Eliminamos 'hold_on_present' y toda lógica de react-hold-on.

  fromStorage = (url: string) => {
    return Constants.BASE_STORAGE + url;
  };

  // ===========================================
  // NUEVAS FUNCIONES DE LOADING BASADAS EN SWAL
  // ===========================================
  setLoading = () => {
    // Muestra un modal de SweetAlert2 con un spinner de carga.
    Swal.fire({
      title: 'Cargando...',
      text: 'Por favor, espere un momento.',
      allowOutsideClick: false, // El usuario no puede hacer clic fuera para cerrarlo
      showConfirmButton: false, // Oculta el botón OK
      willOpen: () => {
        Swal.showLoading(); // Muestra el spinner de carga
      },
    });
  };

  quitLoading = () => {
    // Cierra el modal de SweetAlert2
    Swal.close();
  };
  // ===========================================
  // FIN FUNCIONES DE LOADING
  // ===========================================

  zeroPad = (num: any) => {
    return num.toString().padStart(6, '0');
  };

  formatMiles = (
    n: any,
    decimals: boolean = true,
    currency: string = '$',
    invertPoints = false,
  ) => {
    var c: any = isNaN((c = Math.abs(c))) ? 2 : c,
      d: any = d == undefined ? (invertPoints ? '.' : ',') : d,
      t: any = t == undefined ? (invertPoints ? ',' : '.') : t,
      s: any = n < 0 ? '-' : '',
      i: any = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
      j: any = (j = i.length) > 3 ? j % 3 : 0;

    return (
      currency +
      ' ' +
      s +
      (j ? i.substr(0, j) + t : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) +
      (c
        ? d +
          Math.abs(n - i)
            .toFixed(c)
            .slice(2)
        : '')
    );
  };

  hideTooltip = () => {
    $('button').blur();
    $('a').blur();
  };

  // Nota: 'type' fue reemplazado por 'icon' para compatibilidad moderna de SweetAlert2
  showSuccess = (message: string) => {
    Swal.fire({
      title: '',
      text: message,
      icon: 'success',
      showCancelButton: false,
      confirmButtonColor: colors.swal,
      //   onClose: () => {
      //     this.hideTooltip();
      //   },
    });
  };

  showHtml = (message: string) => {
    Swal.fire({
      title: '',
      html: message,
      icon: 'success',
      showCancelButton: false,
      confirmButtonColor: colors.swal,
    });
  };

  showWarning = (message: string) => {
    Swal.fire({
      title: '',
      text: message,
      icon: 'warning',
      showCancelButton: false,
      confirmButtonColor: colors.swal,
      //   onClose: () => {
      //     this.hideTooltip();
      //   },
    });
  };

  showError = (message?: string, callback?: any) => {
    Swal.fire({
      title: '',
      text: message ? message : 'Por favor, revise su conexión',
      icon: 'error',
      showCancelButton: false,
      confirmButtonColor: colors.swal,
      //   onClose: () => {
      //     callback && callback();
      //     this.hideTooltip();
      //   },
    });
  };

  confirm = (message: string, callback: any) => {
    this.hideTooltip();
    Swal.fire({
      title: '',
      text: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: colors.swal,
      // Utilizamos 'onClose' que se dispara cuando el modal se cierra
      //   onClose: () => {
      //     this.hideTooltip();
      //   },
    }).then((confirm: any) => {
      // Usamos isConfirmed en lugar de value para SweetAlert2 moderno
      if (confirm.isConfirmed) {
        callback();
      }
    });
  };

  clone = (data: any) => {
    return JSON.parse(JSON.stringify(data));
  };

  // El backend ahora serializa fechas en UTC real (ISO 8601 con 'Z') -- ver
  // fix de zona horaria (agosto 2026). `from` ya no tiene un default que
  // asuma el string naive viejo; si no se pasa, moment detecta el ISO y
  // convierte automaticamente a la hora local del navegador. Callers que
  // sigan pasando un `from` explicito (para parsear algo que NO viene del
  // backend, ej. un input del usuario) no se ven afectados.
  getDate = (date: string, to: string = 'DD/MM/YYYY', from?: string) => {
    return (from ? moment(date, from) : moment(date)).format(to);
  };

  capitalize = (text: string) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  isPdf(file: string) {
    return file.substr(file.lastIndexOf('.') + 1) == 'pdf';
  }

  isImage(file: string) {
    const formats = ['png', 'jpg', 'jpeg'];
    return formats.indexOf(file.substr(file.lastIndexOf('.') + 1)) != -1;
  }

  formatPercentage(amount: number) {
    return amount.toFixed(2) + '%';
  }

  pad(num: number | string, size = 4) {
    num = num.toString();
    while (num.length < size) num = '0' + num;
    return num;
  }

  convertDay = (day: number) => {
    switch (day) {
      case 1:
        return 'Lunes';
      case 2:
        return 'Martes';
      case 3:
        return 'Miércoles';
      case 4:
        return 'Jueves';
      case 5:
        return 'Viernes';
      case 6:
        return 'Sábado';
      case 7:
        return 'Domingo';
    }
  };

  clean(cadena: string) {
    var specialChars = '!@#$^&%*()+=-[]/{}|:<>?,.';
    for (var i = 0; i < specialChars.length; i++) {
      cadena = cadena.replace(new RegExp('\\' + specialChars[i], 'gi'), '');
    }
    cadena = cadena.toLowerCase();
    cadena = cadena.replace(/ /g, '_');
    cadena = cadena.replace(/á/gi, 'a');
    cadena = cadena.replace(/é/gi, 'e');
    cadena = cadena.replace(/í/gi, 'i');
    cadena = cadena.replace(/ó/gi, 'o');
    cadena = cadena.replace(/ú/gi, 'u');
    cadena = cadena.replace(/ñ/gi, 'n');
    return cadena;
  }

  isValidIntegerString(value: any): boolean {
    if (typeof value !== 'string') return false;

    const trimmed = value.trim();

    if (!/^\d+$/.test(trimmed)) return false;

    return true;
  }

  getInitials = (name: string) => {
    const words = name.trim().split(' ');
    if (words.length === 1) return name.slice(0, 2).toUpperCase();
    return words
      .slice(0, 2)
      .map((w) => w[0].toUpperCase())
      .join('');
  };
}

export default new Globals();
